import { Link } from 'react-router-dom';
import { Clock, ArrowRight, CheckCircle } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { AuthShell, AuthIcon } from '../../components/layout/AuthShell';

const STEPS = [
  'Wir prüfen deine Registrierung',
  'Wir melden uns für einen kurzen Austausch bei dir',
  'Dein Account wird freigeschaltet',
];

const RegistrationPendingPage = () => {
  return (
    <AuthShell
      testId="registration-pending-page"
      eyebrow="Registrierung"
      title={<>Registrierung <span className="serif-it text-purple">eingegangen.</span></>}
      intro="Vielen Dank für deine Registrierung! Wir prüfen deine Anmeldung und schalten dich kurzfristig frei. Du erhältst eine E-Mail, sobald dein Account aktiviert wurde."
      maxWidth="max-w-lg"
    >
      <AuthIcon tone="amber"><Clock className="w-8 h-8" /></AuthIcon>

      <div className="bg-off border-2 border-ink p-4 mb-6">
        <p className="label-caps text-purple mb-2">Was passiert als Nächstes?</p>
        <ul className="space-y-2">
          {STEPS.map((step) => (
            <li key={step} className="flex items-start gap-2 text-ink/80">
              <CheckCircle className="w-4 h-4 text-green-600 mt-1 flex-shrink-0" />
              <span>{step}</span>
            </li>
          ))}
        </ul>
      </div>

      <div className="border-t-2 border-ink/15 pt-6">
        <p className="text-ink/80 mb-4">
          In der Zwischenzeit kannst du schon jetzt unsere <strong>kostenlose Erstberatung</strong> nutzen:
        </p>
        <Button asChild className="btn--block">
          <Link to="/erstberatung" data-testid="registration-pending-consultation">
            Zur Erstberatung
            <ArrowRight className="w-5 h-5" />
          </Link>
        </Button>
      </div>

      <p className="text-sm text-ink/60 mt-6 text-center">
        Bei Fragen erreichst du uns unter kontakt@gastro-beratung.de
      </p>
    </AuthShell>
  );
};

export default RegistrationPendingPage;
